<app-menu></app-menu>

<section class="controlmonitor-page" *ngIf="tenantId === 1; else noAccess">
  <div class="page-guide">CONTROLPS / MONITORAMENTO</div>

  <section class="dashboard-v2-kpis">
    <article class="dashboard-v2-kpi-card">
      <div class="dashboard-v2-kpi-card__head">
        <span>Usuários (hoje)</span>
        <mat-icon>groups</mat-icon>
      </div>
      <strong>{{ usersByDay.length ? usersByDay[usersByDay.length - 1].value : 0 }}</strong>
      <small>Média 30 dias: {{ usersAverage | number: '1.0-1' }}</small>
    </article>
    <article class="dashboard-v2-kpi-card">
      <div class="dashboard-v2-kpi-card__head">
        <span>Acessos (hoje)</span>
        <mat-icon>login</mat-icon>
      </div>
      <strong>{{ accessesByDay.length ? accessesByDay[accessesByDay.length - 1].value : 0 }}</strong>
      <small>Média 30 dias: {{ accessesAverage | number: '1.0-1' }}</small>
    </article>
    <article class="dashboard-v2-kpi-card">
      <div class="dashboard-v2-kpi-card__head">
        <span>Top tenants por acesso</span>
        <mat-icon>donut_large</mat-icon>
      </div>
      <strong>{{ topTenants.length }}</strong>
      <small>Total de acessos: {{ topTenantTotal }}</small>
    </article>
  </section>

  <section class="dashboard-v2-layout" *ngIf="!loading; else loadingTpl">
    <article class="card dashboard-v2-card dashboard-v2-card--line">
      <header class="dashboard-v2-card__head">
        <h3>Usuários no sistema por dia (30 dias)</h3>
        <span>Últimos 30 dias</span>
      </header>
      <div class="dashboard-v2-line-chart" *ngIf="usersByDay.length; else emptyUsersTpl">
        <canvas
          baseChart
          [type]="'line'"
          [data]="usersChartData"
          [options]="lineChartOptions"></canvas>
      </div>
    </article>

    <article class="card dashboard-v2-card dashboard-v2-card--line">
      <header class="dashboard-v2-card__head">
        <h3>Acessos no sistema por dia (30 dias)</h3>
        <span>Últimos 30 dias</span>
      </header>
      <div class="dashboard-v2-line-chart" *ngIf="accessesByDay.length; else emptyAccessesTpl">
        <canvas
          baseChart
          [type]="'line'"
          [data]="accessesChartData"
          [options]="lineChartOptions"></canvas>
      </div>
    </article>

    <article class="card dashboard-v2-card dashboard-v2-card--donut">
      <header class="dashboard-v2-card__head">
        <h3>Tenants com mais acessos</h3>
        <span>Últimos 30 dias</span>
      </header>

      <div class="dashboard-v2-donut-wrap" *ngIf="topTenants.length; else emptyTenantsTpl">
        <div class="dashboard-v2-donut-canvas">
          <canvas
            baseChart
            [type]="'doughnut'"
            [data]="donutChartData"
            [options]="donutChartOptions"></canvas>
          <div class="dashboard-v2-donut__inner">
            <strong>{{ topTenantTotal }}</strong>
            <small>Acessos</small>
          </div>
        </div>

        <div class="dashboard-v2-status-bars">
          <ng-container *ngFor="let item of topTenants; let i = index">
            <div>
              <span>{{ item.tenant_name }}</span>
              <strong>{{ item.accesses }} · {{ tenantPercent(item) }}%</strong>
            </div>
            <div class="mini-bar">
              <div class="mini-bar__fill" [style.background]="tenantColor(i)" [style.width.%]="tenantPercent(item)"></div>
            </div>
          </ng-container>
        </div>
      </div>
    </article>
  </section>

  <div class="error" *ngIf="error">{{ error }}</div>
</section>

<ng-template #loadingTpl>
  <section class="loading-wrapper">Carregando monitoramento...</section>
</ng-template>

<ng-template #emptyUsersTpl>
  <div class="empty">Sem dados de usuários para o período.</div>
</ng-template>

<ng-template #emptyAccessesTpl>
  <div class="empty">Sem dados de acessos para o período.</div>
</ng-template>

<ng-template #emptyTenantsTpl>
  <div class="empty">Sem acessos de tenants no período.</div>
</ng-template>

<ng-template #noAccess>
  <section class="no-access">
    <h2>Acesso restrito</h2>
    <p>Esta visão é exclusiva do tenant principal do sistema.</p>
  </section>
</ng-template>
